export default "__VITE_ASSET__BcywhhQh__"